import * as three from 'three/src/Three.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
window.three = three;
const addons = {
  OrbitControls,
  GLTFLoader
};
window.threeAddons = window.threeAddons ? {
  ...window.threeAddons,
  ...addons
} : addons;